// extracted by mini-css-extract-plugin
export default {"card":"o5-z"};